import 'normalize.css/normalize.css';
import '../less/loginPage.less';

function bootstrap() {
    let page = '';
    let formStatus = false;
    let autoFillInterval;

    const input = {
        username: document.querySelector('input[name=\'username\']'),
        email: document.querySelector('input[name=\'email\']'),
        password: document.querySelector('input[name=\'password\']'),
        password_confirmation: document.querySelector('input[name=\'password_confirmation\']'),
        submit: document.querySelector('input[type=\'submit\']'),
    };

    const inputsByPage = {
        login:          {
            username: input.username,
            password: input.password,
        },
        passwordReset:  {
            email: input.email,
        },
        passwordSetNew: {
            username:             input.username,
            password:             input.password,
            passwordConfirmation: input.password_confirmation,
        },
        changePassword: {
            password:             input.password,
            passwordConfirmation: input.password_confirmation,
        },
    };

    /* Functions */

    function checkLoginForm() {
        let completedFields = 0;
        let i = 0;

        Object.keys(inputsByPage[page]).forEach(function(name) {
            i++;

            const el = inputsByPage[page][name];

            if(!el.value) {
                return;
            }

            completedFields++;
        });

        // Password Set New & Change Password - password fields must match
        if(
            page === 'passwordSetNew' && completedFields === 3
            || page === 'changePassword' && completedFields === 2
        ) {
            const passwordsNonMatching = document.getElementById('password-non-matching');

            if(inputsByPage[page].password.value !== inputsByPage[page].passwordConfirmation.value) {
                formStatus = false;
                passwordsNonMatching.classList.add('show');
                return;
            }

            passwordsNonMatching.classList.remove('show');
        }

        formStatus = completedFields === i;
    }

    function enableSubmitButton() {
        checkLoginForm();

        const submitButton = input.submit;

        if(page !== 'login' && !formStatus) {
            submitButton.setAttribute('disabled', 'true');
            submitButton.classList.remove('active');

            return;
        }

        submitButton.removeAttribute('disabled');
        submitButton.classList.add('active');
    }

    function checkForAutoFill() {
        let i = 0;

        autoFillInterval = setInterval(
            function() {
                ++i;

                enableSubmitButton();

                if(formStatus || i >= 50) {
                    clearInterval(autoFillInterval);
                }
            }, 100
        );
    }

    function setCurrentPage() {
        switch(document.getElementById('main').getAttribute('data-page').trim()) {
            case 'password-reset':
                page = 'passwordReset';
                break;
            case 'password-set-new':
                page = 'passwordSetNew';
                break;
            case 'change-password':
                page = 'changePassword';
                break;
            default: // login
                page = 'login';
        }
    }

    function reloadRoot() {
        window.location.href = '/';
    }

    function forEach(array, callback, scope) {
        for(let i = 0; i < array.length; i++) {
            callback.call(scope, i, array[i]); // passes back stuff we need
        }
    }

    setCurrentPage();

    /* Set focus */

    switch(page) {
        case 'passwordReset':
        // case 'passwordSetNew':
            inputsByPage[page].email.focus();
            break;
        case 'changePassword':
            inputsByPage[page].password.focus();
            break;
        default: // login
            inputsByPage[page].username.focus();
    }

    /* Prompt Form Validation */

    const nodeList = document.querySelectorAll('input');

    forEach(nodeList, function(i, el) {
        el.onkeyup = enableSubmitButton;
    });

    /* Init */

    enableSubmitButton();
    checkForAutoFill();

    /* Reload page after 119 minutes to prevent session timeout */
    window.setTimeout(reloadRoot, 7140000);
}

document.addEventListener('DOMContentLoaded', bootstrap);



// WEBPACK FOOTER //
// ./resources/assets/js/login.js